import { Trans } from '@lingui/macro';
import clsx from 'clsx';
import Skeleton from 'react-loading-skeleton';
import styles from './RepaymentScheduleLoader.module.css';
import 'react-loading-skeleton/dist/skeleton.css';

type TProps = {
  numberOfRowsLoading: number;
};

export const RepaymentScheduleLoader = ({ numberOfRowsLoading }: TProps) => {
  return (
    <>
      <div
        data-testid="schedule-loader"
        className={styles.scheduleContainerLoading}
      >
        <div className={styles.headerContainerLoading}>
          <div className={styles.headerTitleLoading}>
            <Trans>Date</Trans>
          </div>
          <div className={styles.headerTitleLoading}>
            <Trans>Original loan</Trans>
          </div>
          <div className={styles.headerTitleLoading}>
            <Trans>Fees + interest</Trans>
          </div>
          <div className={styles.headerTitleLoading}>
            <Trans>Total</Trans>
          </div>
        </div>
        {[...Array(numberOfRowsLoading)].map((row, i) => (
          <div key={`loading-row-${i}`} className={styles.rowLoading}>
            <div className={styles.rowCellLoading}>
              <Skeleton width="75%" />
            </div>
            <div className={styles.rowCellLoading}>
              <Skeleton width="75%" />
            </div>
            <div className={styles.rowCellLoading}>
              <Skeleton width="75%" />
            </div>
            <div className={styles.rowCellLoading}>
              <Skeleton width="75%" />
            </div>
          </div>
        ))}
        <div className={styles.footerContainerLoading}>
          <div className={styles.footerTitleLoading}>
            <Trans>Total</Trans>
          </div>
          <div className={styles.footerCellLoading}>
            <Skeleton width="75%" />
          </div>
          <div className={styles.footerCellLoading}>
            <Skeleton width="75%" />
          </div>
          <div className={styles.footerCellLoading}>
            <Skeleton width="75%" />
          </div>
        </div>
      </div>
      <div>
        <Skeleton
          containerClassName={clsx(
            styles.footerLoadingContainer,
            styles.scheduleSavingsLoading,
          )}
          width="70%"
        />
        <Skeleton
          containerClassName={clsx(
            styles.footerLoadingContainer,
            styles.scheduleExampleLoading,
          )}
          height={60}
          width="90%"
        />
        <Skeleton
          containerClassName={clsx(styles.footerLoadingContainer)}
          width="50%"
        />
      </div>
    </>
  );
};
